/**
 * Textos (`es`) del tall «reception» de Qualitat i APPCC (OBR-167). Tall propi: no es toca `es.ts`.
 * Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const receptionEs = {
  'backoffice.qualityReception': {
    // ── Maestro «Condiciones de conservación» ─────────────────────────────────────────
    conservationTempMin: 'Temperatura mínima (°C)',
    conservationTempMax: 'Temperatura máxima (°C)',
    conservationRangeHint:
      'Deja un límite en blanco si no lo hay. Fuera del rango, la recepción pide decidir qué se hace con el género.',
    conservationRequires: 'Hay que anotar la temperatura al recibir',
    conservationRequiresHint:
      'Quien reciba un artículo con esta condición tendrá que escribir la temperatura con la que ha llegado.',
    conservationColRange: 'Rango al recibir',
    conservationColRequires: 'Temperatura obligatoria',
    conservationRangeNone: 'Sin rango',
    conservationRangeBetween: '{{min}} a {{max}} °C',
    conservationRangeAtLeast: 'Mínimo {{min}} °C',
    conservationRangeAtMost: 'Máximo {{max}} °C',
    conservationRequiresYes: 'Sí',
    conservationRequiresNo: 'No',
    conservationTempInvalid: 'Escribe una temperatura entre {{min}} y {{max}} °C.',
    conservationRangeOrder: 'El mínimo no puede ser mayor que el máximo.',

    // ── Control en la línea (registro manual de la recepción) ─────────────────────────
    sectionTitle: 'Control de calidad',
    temperature: 'Temperatura (°C)',
    temperatureRequired: 'Temperatura (°C), obligatoria',
    temperatureRange: 'Rango aceptable: {{range}}',
    temperatureStatus_ok: 'Dentro del rango',
    temperatureStatus_low: 'Por debajo del mínimo',
    temperatureStatus_high: 'Por encima del máximo',
    temperatureMissing: 'Hay que anotar la temperatura.',
    temperatureUnreadable: 'Escribe una temperatura válida (por ejemplo 3,5 o -18).',
    packaging: 'Envase',
    labeling: 'Etiquetado',
    checkNone: 'Sin controlar',
    checkOk: 'OK',
    checkKo: 'KO',
    issuesNotice: 'Algo no cuadra: {{list}}. Se registrará una no conformidad.',
    issue_temperature_out_of_range: 'temperatura fuera de rango',
    issue_packaging_ko: 'envase en mal estado',
    issue_labeling_ko: 'etiquetado incorrecto',
    decision: 'Decisión',
    decisionNone: 'Elige qué se hace',
    decision_accepted: 'Acepta el género',
    decision_accepted_with_incident: 'Acepta con incidencia',
    decision_rejected: 'Rechaza el género',
    decisionMissing: 'Hay que elegir qué se hace con esta entrada.',
    rejectedHint:
      'Rechazar el género lo bloquea en las existencias y deja una devolución pendiente al proveedor.',
    derivedNok: 'No conforme por el control de calidad',
    missingBlocker: 'el control de calidad de alguna entrada (temperatura o decisión)',

    // ── Detalle del albarán ───────────────────────────────────────────────────────────
    colQuality: 'Control de calidad',
    detailTemperature: 'Temperatura: {{value}} °C',
    detailPackaging: 'Envase: {{status}}',
    detailLabeling: 'Etiquetado: {{status}}',
    detailDecision: 'Decisión: {{decision}}',
    detailRecordedAt: 'Controlado el {{when}}',
    detailRecordedBy: 'Controlado por {{user}} el {{when}}',
    detailNonConformity: 'No conformidad {{code}}',
    detailNonConformityOpen: 'Abre {{code}}',
    detailNoControl: '—',
  },
} as const;
